"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _siteLogo = _interopRequireDefault(require("core.ui-module_site-styling/lib/images/site-logo.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SiteHeading = _ref => {
  let {
    siteTitle,
    siteSubTitle
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "site-name columns is-gapless is-vcentered is-mobile",
    style: {
      backgroundImage: `url(${_siteLogo.default})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      width: '300px',
      height: '70px'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "column"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "column"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "title has-text-left"
  }, siteTitle), /*#__PURE__*/_react.default.createElement("h1", {
    className: "title has-text-left"
  }, siteSubTitle)));
};
SiteHeading.propTypes = {
  siteTitle: _propTypes.default.string.isRequired,
  siteSubTitle: _propTypes.default.string.isRequired
};
var _default = exports.default = SiteHeading;
//# sourceMappingURL=SiteHeading.js.map